import React, { useState } from "react";
import { Users } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "./ui/switch";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export function TeamViewToggle({ className = "", testId = "team-view-toggle" }) {
  const { user, impersonateUser } = useAuth();
  const [saving, setSaving] = useState(false);
  if (!user?.team_view_toggle || impersonateUser) return null;
  const on = !!user.team_view_active;

  const change = async (v) => {
    setSaving(true);
    try {
      await api.patch("/me/team-view", { enabled: v });
      toast.success(v ? "Team view ON" : "Team view OFF — showing only your data");
      setTimeout(() => window.location.reload(), 300);
    } catch (e) {
      toast.error(e?.response?.data?.detail?.message || "Could not change team view");
      setSaving(false);
    }
  };

  return (
    <label
      data-testid={testId}
      className={`inline-flex items-center gap-2 h-9 sm:h-11 px-2.5 sm:px-3 rounded-full bg-card border border-border shadow-sm text-xs font-semibold cursor-pointer select-none ${className}`}
    >
      <Users className={`h-4 w-4 ${on ? "text-[#B78E4C]" : "text-muted-foreground"}`} />
      <span className="hidden sm:inline">Team view</span>
      <span data-testid={`${testId}-state`} className={on ? "text-emerald-600 dark:text-emerald-300" : "text-muted-foreground"}>{on ? "ON" : "OFF"}</span>
      <Switch checked={on} disabled={saving} onCheckedChange={change} data-testid={`${testId}-switch`} />
    </label>
  );
}
